
// function updateCartLogic() {
//   let hasSubscription = false;
//   let hasOneTime = false;

//   document.querySelectorAll('.rebuy-cart__flyout-item').forEach((item) => {

//     const isSubscription =
//       item.querySelector('select.rebuy-select') ||
//       item.querySelector('.rebuy-cart__flyout-item-subscription select') ||
//       item.querySelector('.rebuy-select');

//     if (isSubscription) {
//       hasSubscription = true;
//     } else {
//       hasOneTime = true;
//     }
//   });

//   // subtotal
//   const subtotalText =
//     document.querySelector('.rebuy-cart__flyout-subtotal-final-amount span:last-child')
//       ?.innerText || '$0';

//   const subtotal = parseFloat(subtotalText.replace(/[^0-9.]/g, ''));

//   const freeShippingEl = document.querySelector('.rebuy-cart__flyout-free-shipping');

//   // ✅ FINAL CONDITION
//   const showFreeShipping =
//     hasSubscription &&
//     subtotal >= 25;

//   if (showFreeShipping) {
//     freeShippingEl?.style.setProperty('display', 'flex');
//   } else {
//     freeShippingEl?.style.setProperty('display', 'none');
//   }

//   // logs
//   console.clear();
//   console.log('🔁 Has Subscription:', hasSubscription);
//   console.log('❌ Has One-Time:', hasOneTime);
//   console.log('💰 Subtotal:', subtotal);
//   console.log('🚚 Free Shipping:', showFreeShipping);
// }

// function initRebuyWatcher() {
//   const tryAttach = setInterval(() => {
//     const cartEl = document.querySelector('.rebuy-cart__flyout');

//     if (cartEl && !cartEl.dataset.watcherAttached) {
//       cartEl.dataset.watcherAttached = "true";

//       const observer = new MutationObserver(() => {
//         updateCartLogic();
//       });

//       observer.observe(cartEl, {
//         childList: true,
//         subtree: true,
//         characterData: true
//       });

//       updateCartLogic();

//       clearInterval(tryAttach);
//     }
//   }, 300);
// }

// // 🚀 START SCRIPT
// initRebuyWatcher();



function updateCartLogic(cartData) {
  let hasSubscription = false;
  let hasOneTime = false;

  cartData.items.forEach((item) => {
    const isSubscription = !!item.selling_plan_allocation;

    if (isSubscription) {
      hasSubscription = true;
    } else {
      hasOneTime = true;
    }
  });

  const subtotal = cartData.items_subtotal_price / 100; // Shopify cents → dollars

  const freeShippingEl = document.querySelector('.rebuy-cart__flyout-free-shipping');

  // ✅ FINAL CONDITION
  const showFreeShipping =
    hasSubscription && subtotal >= 25;

  if (showFreeShipping) {
    freeShippingEl?.style.setProperty('display', 'flex');
  } else {
    freeShippingEl?.style.setProperty('display', 'none');
  }

  console.clear();
  console.log('🔁 Has Subscription:', hasSubscription);
  console.log('❌ Has One-Time:', hasOneTime);
  console.log('💰 Subtotal:', subtotal);
  console.log('🚚 Free Shipping:', showFreeShipping);
}

function initRebuyWatcher() {
  const tryAttach = setInterval(() => {
    const cartEl = document.querySelector('.rebuy-cart__flyout');

    if (cartEl && !cartEl.dataset.watcherAttached) {
      cartEl.dataset.watcherAttached = "true";

      const observer = new MutationObserver(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => updateCartLogic(cart));
      });

      observer.observe(cartEl, {
        childList: true,
        subtree: true,
        characterData: true
      });

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => updateCartLogic(cart));

      clearInterval(tryAttach);
    }
  }, 300);
}

initRebuyWatcher();